import { IPaymentsInfo, LegalType } from '@/models/orders.model';

export const getPaymentsInfo = (order: IPaymentsInfo[]) => {
  const tovPayment = order?.find((i) => i.legalType === LegalType.TOV);
  return tovPayment ? [tovPayment, ...order?.filter((i) => i !== tovPayment)] : order;
};
